import { Checkbox, Textarea } from '@nextui-org/react'
import CreateDropZone from './CreateDropZone'

export default function CompanyESG({ formData, handleChange, userUUID }: any) {
  return (
    <div className="flex flex-col gap-4">
      <Checkbox
        defaultSelected
        radius="full"
        onChange={(e) => handleChange?.('haveEnvPolicy', e.target.checked)}
        checked={formData?.haveEnvPolicy}
      >
        Have Environmental Policy
      </Checkbox>
      {formData?.haveEnvPolicy && (
        <div className="flex flex-row gap-4">
          <div className="flex flex-1">
            <Textarea
              label="Description"
              labelPlacement="outside"
              variant="bordered"
              placeholder="Describe your strategy for reducing environmental impact."
              classNames={{
                inputWrapper: 'flex flex-1',
              }}
              value={formData?.envPolicyText}
              onChange={(e) => handleChange?.('envPolicyText', e.target.value)}
            />
          </div>
          <div className="flex flex-1">
            <CreateDropZone
              title={'Attachments'}
              description="."
              onFilesChange={(files) => handleChange?.('envPolicyFile', files)}
              userUUID={userUUID}
              files={formData?.envPolicyFile ?? []}
            />
          </div>
        </div>
      )}
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Sustainability Certifications"
            labelPlacement="outside"
            variant="bordered"
            placeholder="ISO 14001, EMAS, etc.,"
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            value={formData?.sustainailityCertifications}
            onChange={(e) => handleChange?.('sustainailityCertifications', e.target.value)}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Certificates'}
            description="."
            onFilesChange={(files) => handleChange?.('sustainailityCertificationsFiles', files)}
            userUUID={userUUID}
            files={formData?.sustainailityCertificationsFiles ?? []}
          />
        </div>
      </div>
      <Textarea
        label="Diversity & Inclusion (DEI)"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Outline DEI policy and initiatives."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('diversityInclusion', e.target.value)}
        value={formData?.diversityInclusion}
      />
      <Textarea
        label="Corporate Social Responsibility (CSR) Initiatives"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Describe community or charitable programs"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('csrInitiative', e.target.value)}
        value={formData?.csrInitiative}
      />
      <Textarea
        label="Governance & Ethical Practices"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Summarise ethics code and governance"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.governancePractices}
        onChange={(e) => handleChange?.('governancePractices', e.target.value)}
      />
    </div>
  )
}
